import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getRequest, postRequest } from '../../globalhelper/helper'
import ApiConstants from '../../config.json'
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  Alert,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  IconButton,
  InputLabel,
  FormControl,
  Autocomplete,
  Tooltip,
  Divider,
  Fade,
  InputAdornment,
  Avatar,
  Badge,
  CircularProgress,
  Popover
} from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1'
import SecurityIcon from '@mui/icons-material/Security'
import DeleteIcon from '@mui/icons-material/Delete'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import SearchIcon from '@mui/icons-material/Search'
import PhotoCamera from '@mui/icons-material/PhotoCamera'
import { showAlert } from '../../redux/Common/commonActions'
import HistoryIcon from '@mui/icons-material/History'
import WarningIcon from '@mui/icons-material/Warning'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'
import { alpha } from '@mui/material/styles'
import axios from 'axios'
import MenuManagement from './MenuManagement'

function stringToColor(string) {
  let hash = 0;
  let i;
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
}

const arrayBufferToBase64 = (buffer) => {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
};
function AdminScreen() {
  const [alertInfo, setAlertInfo] = useState({ open: false, message: '', severity: 'info' })
  const [AllUsers, setAllUsers] = useState([])
  const [All_RA, setAll_RA] = useState([])
  const [AllRoleNames, setAllRoleNames] = useState([])
  const [All_UPA, setAll_UPA] = useState([])
  const [All_Modules, setAll_Modules] = useState([])
  const [All_Menus, setAll_Menus] = useState([])
  const [AllAuditLogs, setAllAuditLogs] = useState([])
  const [allMenusData, setAllMenusData] = useState([])

  const [tabIndex, setTabIndex] = useState(0)
  const [isAdminUser, setIsAdminUser] = useState(false)

  // Form States
  const [nameofuser, setnameofuser] = useState('')
  const [Email, setEmail] = useState('')
  const [Pass, setPass] = useState('')
  const [RoleType, setRoleType] = useState('')
  const [RoleName, setRoleName] = useState('')
  const [Items, setItems] = useState('')
  const [Process, setProcess] = useState('')
  const [Role, setRole] = useState('')
  const [company, setCompany] = useState('')
  const [organization, setOrganization] = useState('')

  // Extended User Fields
  const [Mobile_Num, setMobile_Num] = useState('')
  const [docEmail, setDocEmail] = useState('')
  const [appPassword, setAppPassword] = useState('')
  const [imageUrl, setImageUrl] = useState('')
  const [Tenant, setTenant] = useState('')
  const [Address1, setAddress1] = useState('')
  const [Address2, setAddress2] = useState('')
  const [City, setCity] = useState('')
  const [State, setStateVar] = useState('')
  const [Country, setCountry] = useState('')
  const [Zip, setZip] = useState('')

  // Tenants Array Management
  const [Tenants, setTenants] = useState([])
  const [tenantOrgInput, setTenantOrgInput] = useState('')
  const [tenantIdInput, setTenantIdInput] = useState('')
  const [tenantImageInput, setTenantImageInput] = useState('')
  const [profileImageBinary, setProfileImageBinary] = useState('')
  const [editingTenantIndex, setEditingTenantIndex] = useState(-1)
  const [tenantImageBinaries, setTenantImageBinaries] = useState({}) // Keyed by tenant index or ID
  const [tenantCompanies, setTenantCompanies] = useState([]) // Array of fetched companies for the tenant
  const isMounted = useRef(true)

  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    if (Tenant) {
      getRequest(`api/edureka/getOrganizationData?tenantID=${Tenant}`).then(res => {
        if (isMounted.current) {
          const data = res?.res?.data || res?.res || res?.data || []
          setTenantCompanies(Array.isArray(data) ? data : [])
        }
      }).catch(err => {
        if (isMounted.current) setTenantCompanies([])
      })
    } else {
      setTenantCompanies([])
    }
  }, [Tenant])
  const handleAddTenant = () => {
    if (tenantOrgInput && tenantIdInput) {
      if (editingTenantIndex !== -1) {
        // Update existing
        const newTenants = [...Tenants]
        let fileName = newTenants[editingTenantIndex].Image || ''

        if (tenantImageInput && tenantImageInput.startsWith('data:image/')) {
          const extension = tenantImageInput.split(';')[0]?.split('/')[1] || 'png'
          fileName = `${tenantIdInput}.${extension}`
          setTenantImageBinaries(prev => ({ ...prev, [fileName]: tenantImageInput }))
        }

        newTenants[editingTenantIndex] = { Organisation: tenantOrgInput, Tenant_ID: tenantIdInput, Image: fileName }
        setTenants(newTenants)

        setEditingTenantIndex(-1)
        setTenantOrgInput('')
        setTenantIdInput('')
        setTenantImageInput('')
      } else {
        // Add new
        let fileName = ''
        if (tenantImageInput && tenantImageInput.startsWith('data:image/')) {
          const extension = tenantImageInput.split(';')[0]?.split('/')[1] || 'png'
          fileName = `${tenantIdInput}.${extension}`
          setTenantImageBinaries(prev => ({ ...prev, [fileName]: tenantImageInput }))
        }
        setTenants([...Tenants, { Organisation: tenantOrgInput, Tenant_ID: tenantIdInput, Image: fileName }])

        setTenantOrgInput('')
        setTenantIdInput('')
        setTenantImageInput('')
      }
    }
  }

  const handleEditTenant = (index) => {
    const tenant = Tenants[index]
    setTenantOrgInput(tenant.Organisation)
    setTenantIdInput(tenant.Tenant_ID)
    setTenantImageInput(tenant.Image || '')
    setEditingTenantIndex(index)
  }

  const handleRemoveTenant = (index) => {
    setTenants(Tenants.filter((_, i) => i !== index))
  }

  const [buttonLoading, setButtonLoading] = useState(false)
  const [passwordErrors, setPasswordErrors] = useState([])
  const [showErrors, setShowErrors] = useState(false)
  const [passwordAnchorEl, setPasswordAnchorEl] = useState(null)

  const [showCreateUserModal, setShowCreateUserModal] = useState(false)
  const [isEditMode, setIsEditMode] = useState(false)
  const [userSearchQuery, setUserSearchQuery] = useState('')
  const [logSearchQuery, setLogSearchQuery] = useState('')
  const [userConfirmOpen, setUserConfirmOpen] = useState(false)
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false)
  const [userToDelete, setUserToDelete] = useState(null)

  const [roleConfirmOpen, setRoleConfirmOpen] = useState(false)
  const [roleToDelete, setRoleToDelete] = useState(null)
  const [roleKeyToDelete, setRoleKeyToDelete] = useState(null)
  const [roleConfirmModalOpen, setRoleConfirmModalOpen] = useState(false)
  const [userSaveConfirmModalOpen, setUserSaveConfirmModalOpen] = useState(false)
  const [fetchedAvatarData, setFetchedAvatarData] = useState('')
  const [avatarFetchError, setAvatarFetchError] = useState(false)

  const [infraDialogBoxOpen, setInfraDialogBoxOpen] = useState(false)
  const [infraEnv, setInfraEnv] = useState('dev')
  const [infraResults, setInfraResults] = useState(null)
  const [infraLoading, setInfraLoading] = useState(false)
  const [infraXlsxPath, setInfraXlsxPath] = useState('')

  const state = useSelector(state => state)
  let dispatch = useDispatch()

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!imageUrl || imageUrl === 'organization') {
      setFetchedAvatarData('')
      setAvatarFetchError(true)
      return
    }

    if (imageUrl.startsWith('data:image/')) {
      setFetchedAvatarData(imageUrl)
      setAvatarFetchError(false)
      return
    }

    axios.get(ApiConstants.externals.serverUrl + `api/user/getUserAvatar?USR_imageUrl=${imageUrl}`, { responseType: 'arraybuffer' })
      .then(res => {
        if (res.data) {
          const contentType = res.headers['content-type'] || 'image/png';
          const base64 = arrayBufferToBase64(res.data);
          setFetchedAvatarData(`data:${contentType};base64,${base64}`);
          setAvatarFetchError(false);
        } else {
          setFetchedAvatarData('')
          setAvatarFetchError(true)
        }
      })
      .catch(() => {
        setFetchedAvatarData('')
        setAvatarFetchError(true)
      })
  }, [imageUrl])

  const fetchData = () => {
    getRequest('api/admin/getSession').then(sessionRes => {
      const isAdminUser = sessionRes?.res?.data?.isAdmin || false;
      console.log(sessionRes, sessionRes?.res?.data, isAdminUser);

      if (isMounted.current) {
        setIsAdminUser(isAdminUser)
        if (isAdminUser) {
          getRequest(`api/admin/getAllUsers`).then(res => {
            if (isMounted.current) setAllUsers(res?.res?.data || [])
          })
          getRequest(`api/admin/getAll_RA`).then(res => {
            if (isMounted.current) {
              const data = res?.res?.data || []
              setAll_RA(data)
              setAllRoleNames([...new Set(data.map(each => each.RoleName))])
            }
          })
          getRequest(`api/admin/getAll_UPA`).then(res => {
            if (isMounted.current) setAll_UPA(res?.res?.data || [])
          })
          getRequest(
            `api/admin/getAll_Modules?module=${sessionStorage.getItem('module') || sessionStorage.getItem('module')}`
          ).then(res => {
            if (isMounted.current) setAll_Modules(res?.res?.data || [])
          })
          getRequest(`api/admin/getAll_Menus`).then(res => {
            if (isMounted.current) setAll_Menus(res?.res?.data || [])
          })
          getRequest(`api/admin/getAuditLogs`).then(res => {
            if (isMounted.current) setAllAuditLogs(res?.res?.data || [])
          })
          fetchMenuData()
        } else {
          getRequest(`api/admin/getAllUsers`).then(res => {
            if (isMounted.current) setAllUsers(res?.res?.data || [])
          })
        }
      }
    })
  }

  const fetchMenuData = () => {
    getRequest(`api/admin/getAllMenus`).then(res => {
      if (isMounted.current) setAllMenusData(res?.res?.data || [])
    })
  }


  function validateEmailFormat(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  function isStrongPassword(password) {
    const minLength = 8
    const hasUpperCase = /[A-Z]/.test(password)
    const hasLowerCase = /[a-z]/.test(password)
    const hasNumbers = /[0-9]/.test(password)
    const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password)

    if (password.length < minLength) return 'Password must be at least 8 characters long.'
    if (!hasUpperCase) return 'Password must contain at least one uppercase letter.'
    if (!hasLowerCase) return 'Password must contain at least one lowercase letter.'
    if (!hasNumbers) return 'Password must contain at least one number.'
    if (!hasSpecialChars) return 'Password must contain at least one special character.'

    return true
  }

  const validatePassword = password => {
    const errors = []
    const minLength = 8
    const hasUpperCase = /[A-Z]/.test(password)
    const hasLowerCase = /[a-z]/.test(password)
    const hasNumbers = /[0-9]/.test(password)
    const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(password)

    if (password.length < minLength) {
      errors.push('❌ Password must be at least 8 characters long.')
    } else {
      errors.push('✔️ Password length is sufficient.')
    }
    if (!hasUpperCase) {
      errors.push('❌ Password must contain at least one uppercase letter.')
    } else {
      errors.push('✔️ Contains uppercase letter.')
    }
    if (!hasLowerCase) {
      errors.push('❌ Password must contain at least one lowercase letter.')
    } else {
      errors.push('✔️ Contains lowercase letter.')
    }
    if (!hasNumbers) {
      errors.push('❌ Password must contain at least one number.')
    } else {
      errors.push('✔️ Contains number.')
    }
    if (!hasSpecialChars) {
      errors.push('❌ Password must contain at least one special character.')
    } else {
      errors.push('✔️ Contains special character.')
    }
    return errors
  }

  const handlePasswordChange = e => {
    const password = e.target.value
    setPass(password)
    setPasswordErrors(validatePassword(password))
  }

  const closeUserModal = () => {
    setShowCreateUserModal(false)
    setIsEditMode(false)
    setnameofuser('')
    setEmail('')
    setPass('')
    setCompany('')
    setOrganization('')
    setRole('')
    setMobile_Num('')
    setDocEmail('')
    setAppPassword('')
    setImageUrl('')
    setTenant('')
    setAddress1('')
    setAddress2('')
    setCity('')
    setStateVar('')
    setCountry('')
    setZip('')
    setTenants([])
    setTenantOrgInput('')
    setTenantIdInput('')
    setTenantImageInput('')
    setProfileImageBinary('')
    setTenantImageBinaries({})
    setEditingTenantIndex(-1)
    setPasswordErrors([])
  }

  const handleEditUser = (item) => {
    setIsEditMode(true)
    setnameofuser(item.USR_Name || '')
    setEmail(item.USR_Email || '')
    setPass('')
    setOrganization(item.USR_Organization)
    setCompany(item.USR_Role?.split('-')[0])
    setRole(`${item.USR_Role?.split('-')[1]}${item.USR_Role?.split('-')[2] && '-' + item.USR_Role?.split('-')[2]}`)
    setMobile_Num(item.USR_Mobile_Num || '')
    setDocEmail(item.USR_DocEmail || '')
    setAppPassword(item.USR_AppPassword || '')
    setImageUrl(item.USR_imageUrl || '')
    setTenant(item.USR_Tenant || '')
    setAddress1(item.USR_Address1 || '')
    setAddress2(item.USR_Address2 || '')
    setCity(item.USR_City || '')
    setStateVar(item.USR_State || '')
    setCountry(item.USR_Country || '')
    setZip(item.USR_Zip || '')

    let parsedTenants = item.USR_Tenants || []
    if (parsedTenants.L) parsedTenants = parsedTenants.L;
    if (parsedTenants.length > 0 && (parsedTenants[0].M || typeof parsedTenants[0] === 'object')) {
      parsedTenants = parsedTenants.map(t => ({
        Organisation: t.M?.Organisation?.S || t.Organisation || '',
        Tenant_ID: t.M?.Tenant_ID?.S || t.Tenant_ID || '',
        Image: t.M?.Image?.S || t.Image || ''
      }))
    }
    setTenants(parsedTenants)
    setShowCreateUserModal(true)

    if (parsedTenants) {
      parsedTenants.forEach(t => {
        if (t.Image) {
          axios.get(ApiConstants.externals.serverUrl + `api/user/getTenantAvatar?fileName=${t.Image}`, { responseType: 'arraybuffer' }).then(res => {
            if (res.data) {
              const contentType = res.headers['content-type'] || 'image/png';
              const base64 = arrayBufferToBase64(res.data);
              setTenantImageBinaries(prev => ({ ...prev, [t.Image]: `data:${contentType};base64,${base64}` }));
            }
          })
        }
      })
    }
  }

  const handleSaveUser = () => {
    let isStrongPass = true
    if (!isEditMode || Pass) {
      isStrongPass = isStrongPassword(Pass)
    }

    if (!validateEmailFormat(Email)) {
      dispatch(showAlert('Invalid email format', "error"))
      return
    } else if ((!isEditMode || Pass) && typeof isStrongPass === 'string') {
      dispatch(showAlert(isStrongPass, "error"))
      return
    } else {
      setButtonLoading(true)
      const userPayload = {
        USR_Name: nameofuser,
        USR_Email: Email,
        USR_Organization: organization,
        USR_Role: company ? `${company}-${Role}` : Role,
        USR_Mobile_Num: Mobile_Num,
        USR_DocEmail: docEmail,
        USR_AppPassword: appPassword,
        USR_imageUrl: imageUrl && !imageUrl.startsWith('data:image/') ? imageUrl : (Email ? `${Email.replace(/[@.]/g, '_')}_profile.png` : ''),
        USR_Tenant: Tenant,
        USR_Address1: Address1,
        USR_Address2: Address2,
        USR_City: City,
        USR_State: State,
        USR_Country: Country,
        USR_Zip: Zip,
        USR_Tenants: Tenants,
        USR_Password: Pass
      }

      if (isEditMode) {
        const currentUser = AllUsers.find(u => u.USR_Email === Email)
        userPayload.id = currentUser?.id
      }

      const endpoint = isEditMode ? `api/admin/UpdateUser` : `api/admin/CreateNewUser`

      const fullPayload = {
        userData: userPayload,
        profileImageBinary: profileImageBinary,
        tenantImageBinaries: tenantImageBinaries
      }

      postRequest(endpoint, fullPayload).then(() => {
        getRequest(`api/admin/getAllUsers`).then(res => {
          if (res.res.status === 'success') {
            setAllUsers(res?.res?.data || [])
            setUserSaveConfirmModalOpen(false)
            closeUserModal()
          }
        })
      }).finally(() => setButtonLoading(false))
    }
  }

  const DeleteUser = (emailToDelete) => {
    setButtonLoading(true)
    getRequest(`api/admin/DeleteUser?email=${emailToDelete}`).then(() => {
      getRequest(`api/admin/getAllUsers`).then(res => {
        setAllUsers(res?.res?.data || [])
      })
    }).finally(() => setButtonLoading(false))
  }

  const confirmDeleteAction = (email) => {
    setUserToDelete(email)
    setDeleteConfirmModalOpen(true)
  }

  const handleDeleteConfirm = () => {
    if (userToDelete) {
      DeleteUser(userToDelete)
      setDeleteConfirmModalOpen(false)
      setUserToDelete('')
    }
  }

  const handleDeleteCancel = () => {
    setDeleteConfirmModalOpen(false)
    setUserToDelete('')
  }

  const CreateRole = () => {
    setButtonLoading(true)
    let send = {
      RoleType: RoleType,
      RoleName: RoleType === 'New Role' ? `${RoleName}-${Items}` : RoleName,
      Items: Items
    }

    postRequest(`api/admin/CreateRole`, send).then(() => {
      getRequest(`api/admin/getAll_UPA`).then(res => setAll_UPA(res?.res?.data || []))
      getRequest(`api/admin/getAll_RA`).then(res => {
        const data = res?.res?.data || []
        setAll_RA(data)
        setAllRoleNames([...new Set(data.map(each => each.RoleName))])
        setItems('')
      })
    }).finally(() => setButtonLoading(false))
  }

  const MapRole = () => {
    setButtonLoading(true)
    let send = {
      RoleName: RoleName,
      Process: Process,
      Email: Email
    }
    postRequest(`api/admin/Map_Or_UnMap_Role`, send).then(() => {
      getRequest(`api/admin/getAll_UPA`).then(res => {
        setAll_UPA(res?.res?.data || [])
        setRoleConfirmModalOpen(false)
      })
    }).finally(() => setButtonLoading(false))
  }

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue)
    // Clear forms when switching tabs to avoid stale state
    setRoleName('')
    setRoleType('')
    setItems('')
    setEmail('')
    setProcess('')
  }
  // Common UI styling
  const cardStyle = {
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
    mb: 4,
    border: '1px solid rgba(0,0,0,0.08)'
  }

  const tableHeaderStyle = {
    backgroundColor: '#f8fafc',
    fontWeight: 600,
    color: '#1e293b'
  }

  const filteredUsers = AllUsers.filter(item => {
    if (!userSearchQuery) return true;
    const q = userSearchQuery.toLowerCase();
    return (
      (item.USR_Email && item.USR_Email.toLowerCase().includes(q)) ||
      (item.USR_Name && item.USR_Name.toLowerCase().includes(q)) ||
      (item.USR_Organization && item.USR_Organization.toLowerCase().includes(q)) ||
      (item.USR_Tenant && item.USR_Tenant.toLowerCase().includes(q))
    );
  });

  const runInfraSetup = () => {
    if (!Tenant) {
      dispatch(showAlert('Please enter Primary Tenant ID first', 'error'))
      return
    }
    setInfraLoading(true)
    postRequest('api/admin/setupTenantInfrastructure', {
      tenantid: Tenant,
      environment: infraEnv,
      productCode: sessionStorage.getItem('module')
    }).then(res => {
      if (res?.res?.status === 'success') {
        setInfraResults(res?.res?.data)
      } else {
        dispatch(showAlert(res?.res?.message || 'Failed to setup infrastructure', 'error'))
      }
    }).catch(err => {
      console.error(err)
      dispatch(showAlert('Error occurred during infrastructure setup', 'error'))
    }).finally(() => {
      setInfraLoading(false)
    })
  }

  return (<>
    <Box sx={{ p: { xs: 2, sm: 4 }, minHeight: '100vh', backgroundColor: '#fcfcfc' }}>
      <Typography variant="h6" sx={{ mb: 1, fontWeight: 700, color: '#1e293b' }}>
        Admin Dashboard
      </Typography>

      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ mb: 3 }}
      >
        <Tab icon={<PersonAddAlt1Icon />} iconPosition="start" label="User Management" />
        {isAdminUser && (
          <Tab icon={<SecurityIcon />} iconPosition="start" label="Role Management" />
        )}
        {isAdminUser && (
          <Tab icon={<AssignmentIndIcon />} iconPosition="start" label="Role Mapping" />
        )}
        {isAdminUser && (
          <Tab icon={<HistoryIcon />} iconPosition="start" label="Audit Logs" />
        )}
        {isAdminUser && (
          <Tab icon={<AccountTreeIcon />} iconPosition="start" label="Menu Management" />
        )}
      </Tabs>

      <Divider sx={{ mb: 4 }} />

      {/* TAB 0 - User Management */}
      {tabIndex === 0 && (
        <Fade in timeout={500}>
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 2 }}>
              <TextField
                size="small"
                placeholder="Search users..."
                value={userSearchQuery}
                onChange={e => setUserSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                sx={{ width: { xs: '100%', sm: 300 }, backgroundColor: '#fff', borderRadius: '4px' }}
              />
              {isAdminUser && (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => setShowCreateUserModal(true)}
                  sx={{ borderRadius: '8px', textTransform: 'none', fontWeight: 600 }}
                >
                  Create New User
                </Button>
              )}
            </Box>

            <Card sx={cardStyle}>
              <CardContent sx={{ p: 0 }}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={tableHeaderStyle}>User Email</TableCell>
                        <TableCell sx={tableHeaderStyle}>User Name</TableCell>
                        <TableCell sx={tableHeaderStyle}>Organization</TableCell>
                        <TableCell sx={tableHeaderStyle}>Tenant</TableCell>
                        <TableCell sx={{ ...tableHeaderStyle, textAlign: 'right' }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredUsers.map((item, idx) => (
                        <TableRow key={idx} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell>{item.USR_Email}</TableCell>
                          <TableCell>{item.USR_Name}</TableCell>
                          <TableCell>{item.USR_Organization}</TableCell>
                          <TableCell>{item.USR_Tenant}</TableCell>
                          <TableCell sx={{ textAlign: 'right' }}>
                            <Tooltip title="Edit User">
                              <span>
                                <IconButton
                                  color="primary"
                                  onClick={() => handleEditUser(item)}
                                  disabled={buttonLoading}
                                  size="small"
                                >
                                  <EditIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                            {isAdminUser && state?.login?.userData?.USR_Email !== item.USR_Email && (
                              <Tooltip title="Remove User">
                                <span>
                                  <IconButton
                                    color="error"
                                    onClick={() => confirmDeleteAction(item.USR_Email)}
                                    disabled={buttonLoading}
                                    size="small"
                                  >
                                    <DeleteOutlineIcon />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                      {filteredUsers.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={5} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                            No users found.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>

            {/* Create User Dialog */}
            <Dialog
              open={showCreateUserModal}
              onClose={closeUserModal}
              maxWidth="md"
              fullWidth
              PaperProps={{ sx: { borderRadius: '12px' } }}
            >
              <DialogTitle sx={{ fontWeight: 600 }}>{isEditMode ? 'Edit User' : 'Create New User'}</DialogTitle>
              <DialogContent dividers>
                <Grid container spacing={3}>
                  <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mb: 1, pointerEvents: isAdminUser ? 'auto' : 'none', opacity: isAdminUser ? 1 : 0.7 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, width: '100%' }}>
                      <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        badgeContent={
                          <IconButton component="label" sx={{ bgcolor: 'white', border: '1px solid #ccc', '&:hover': { bgcolor: '#f0f0f0' }, p: 0.5 }}>
                            <PhotoCamera fontSize="small" />
                            <input hidden accept="image/*" type="file" onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const reader = new FileReader();
                                reader.onload = (ev) => {
                                  setProfileImageBinary(ev.target.result);
                                  setFetchedAvatarData(ev.target.result);
                                };
                                reader.readAsDataURL(file);
                              }
                            }} />
                          </IconButton>
                        }
                      >
                        {!avatarFetchError && fetchedAvatarData ? (
                          <Avatar src={fetchedAvatarData} sx={{ width: 72, height: 72 }} />
                        ) : (
                          <Avatar sx={{ bgcolor: nameofuser ? stringToColor(nameofuser) : '#ccc', width: 72, height: 72, fontSize: '2rem' }}>
                            {nameofuser ? nameofuser.charAt(0).toUpperCase() : 'U'}
                          </Avatar>
                        )}
                      </Badge>
                      <TextField
                        size="small"
                        label="Profile Image URL (Or Upload directly via Avatar)"
                        fullWidth
                        value={imageUrl || (nameofuser && organization ? `${nameofuser}+${organization}` : '')}
                        onChange={e => setImageUrl(e.target.value)}
                        placeholder={`${nameofuser || 'Name'}+${organization || 'Organization'}`}
                        disabled={!isAdminUser}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary">Basic Info</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Name"
                      required
                      value={nameofuser}
                      onChange={e => setnameofuser(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Email"
                      required
                      type="email"
                      value={Email}
                      onChange={e => setEmail(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label={isEditMode ? "Update Password (Optional)" : "Password"}
                      placeholder={isEditMode ? "Leave blank to keep current" : ""}
                      type="text"
                      value={Pass}
                      onChange={handlePasswordChange}
                      onFocus={(e) => { setShowErrors(true); setPasswordAnchorEl(e.currentTarget); }}
                      onBlur={() => { setShowErrors(false); setPasswordAnchorEl(null); }}
                      error={passwordErrors.length > 0 && typeof isStrongPassword(Pass) === 'string'}
                      disabled={!isAdminUser}
                    />
                    <Popover
                      open={showErrors && Boolean(passwordAnchorEl) && passwordErrors.length > 0}
                      anchorEl={passwordAnchorEl}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                      disableAutoFocus
                      disableEnforceFocus
                      style={{ pointerEvents: 'none' }}
                    >
                      <Box sx={{ p: 2 }}>
                        <ul style={{ listStyleType: 'none', paddingLeft: '0', margin: '0', fontSize: '0.85rem' }}>
                          {passwordErrors.map((err, index) => (
                            <li key={index} style={{ color: err.startsWith('✔️') ? 'green' : '#d32f2f' }}>
                              {err}
                            </li>
                          ))}
                        </ul>
                      </Box>
                    </Popover>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Mobile Number"
                      value={Mobile_Num}
                      onChange={e => setMobile_Num(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Document Receiving Email"
                      type="email"
                      value={docEmail}
                      onChange={e => setDocEmail(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="App Password"
                      type="text"
                      value={appPassword}
                      onChange={e => setAppPassword(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary">Organization & Role Info</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      freeSolo
                      size="small"
                      options={[...new Set(tenantCompanies.map(c => c.orgname).filter(Boolean))]}
                      value={organization}
                      onInputChange={(e, val) => setOrganization(val)}
                      renderInput={(params) => (
                        <TextField {...params} label="Organization" />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      freeSolo
                      size="small"
                      options={[...new Set(tenantCompanies.map(c => c.orgid).filter(Boolean))]}
                      value={company}
                      onInputChange={(e, val) => setCompany(val)}
                      renderInput={(params) => (
                        <TextField {...params} label="Company Name" required />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      freeSolo
                      size="small"
                      options={['Admin-User', 'Dev-User']}
                      value={Role}
                      onInputChange={(e, val) => setRole(val)}
                      renderInput={(params) => (
                        <TextField {...params} label="Role" required />
                      )}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Primary Tenant ID"
                      required
                      value={Tenant}
                      onChange={e => setTenant(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Tooltip title="Setup Infrastructure (S3, DynamoDB, PostgreSQL)">
                              <IconButton
                                size="small"
                                color="primary"
                                onClick={() => {
                                  setInfraResults(null)
                                  setInfraDialogBoxOpen(true)
                                }}
                              >
                                <RocketLaunchIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </InputAdornment>
                        )
                      }}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary">Address Info</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Address Line 1"
                      value={Address1}
                      onChange={e => setAddress1(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Address Line 2"
                      value={Address2}
                      onChange={e => setAddress2(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="City"
                      value={City}
                      onChange={e => setCity(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="State"
                      value={State}
                      onChange={e => setStateVar(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Country"
                      value={Country}
                      onChange={e => setCountry(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Zip Code"
                      value={Zip}
                      onChange={e => setZip(e.target.value)}
                      disabled={!isAdminUser}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Divider />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" color="primary">Additional Tenants Array</Typography>
                  </Grid>
                  <Grid item xs={12} container spacing={2} alignItems="center">
                    <Grid item xs={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Organisation"
                        value={tenantOrgInput}
                        onChange={e => setTenantOrgInput(e.target.value)}
                        disabled={!isAdminUser}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Tenant ID"
                        value={tenantIdInput}
                        onChange={e => setTenantIdInput(e.target.value)}
                        disabled={!isAdminUser}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <Button component="label" fullWidth variant="outlined" size="small" sx={{ borderColor: tenantImageInput ? 'success.main' : '', color: tenantImageInput ? 'success.main' : '' }} disableElevation disabled={!isAdminUser}>
                        {tenantImageInput ? 'Image Attached' : 'Upload Image'}
                        <input hidden accept="image/*" type="file" onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            const reader = new FileReader();
                            reader.onload = (ev) => {
                              setTenantImageInput(ev.target.result);
                            };
                            reader.readAsDataURL(file);
                          }
                        }} />
                      </Button>
                    </Grid>
                    <Grid item xs={2}>
                      <Button
                        variant="contained"
                        size="small"
                        fullWidth
                        onClick={handleAddTenant}
                        disabled={!tenantOrgInput || !tenantIdInput || !isAdminUser}
                      >
                        {editingTenantIndex !== -1 ? 'Update' : 'Add'}
                      </Button>
                    </Grid>
                  </Grid>

                  {Tenants.length > 0 && (
                    <Grid item xs={12}>
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {Tenants.map((t, idx) => (
                          <Box key={idx} sx={{
                            p: 1,
                            border: editingTenantIndex === idx ? '2px solid #3b82f6' : '1px solid #ddd',
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            bgcolor: editingTenantIndex === idx ? alpha('#3b82f6', 0.05) : '#fafafa'
                          }}>
                            {tenantImageBinaries[t.Image] && <Avatar src={tenantImageBinaries[t.Image]} sx={{ width: 22, height: 22 }} />}
                            <Typography variant="caption">{t.Organisation} ({t.Tenant_ID})</Typography>
                            <Box sx={{ display: 'flex', gap: 0.5, pointerEvents: isAdminUser ? 'auto' : 'none', opacity: isAdminUser ? 1 : 0.5 }}>
                              <IconButton size="small" color="primary" onClick={() => handleEditTenant(idx)} sx={{ p: 0.2 }} disabled={!isAdminUser}>
                                <EditIcon fontSize="small" />
                              </IconButton>
                              <IconButton size="small" color="error" onClick={() => handleRemoveTenant(idx)} sx={{ p: 0.2 }} disabled={!isAdminUser}>
                                <DeleteOutlineIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </DialogContent>
              <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={closeUserModal} color="error">Cancel</Button>
                <Button
                  onClick={() => setUserSaveConfirmModalOpen(true)}
                  variant="contained"
                  color="primary"
                  disabled={!nameofuser || !Email || !company || !Role || !Tenant || (!isEditMode && !Pass) || buttonLoading}
                >
                  {buttonLoading ? <CircularProgress size={24} color="inherit" /> : (isEditMode ? 'Save Changes' : 'Create User')}
                </Button>
              </DialogActions>
            </Dialog>

            {/* Confirm Delete Dialog */}
            <Dialog
              open={deleteConfirmModalOpen}
              onClose={handleDeleteCancel}
              PaperProps={{ sx: { borderRadius: '12px', minWidth: '350px' } }}
            >
              <DialogTitle sx={{ fontWeight: 600, color: '#d32f2f' }}>Confirm Deletion</DialogTitle>
              <DialogContent>
                <Typography>Are you sure you want to delete user <strong>{userToDelete}</strong>? This action cannot be undone.</Typography>
              </DialogContent>
              <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={handleDeleteCancel} color="inherit">Cancel</Button>
                <Button
                  onClick={handleDeleteConfirm}
                  variant="contained"
                  color="error"
                  disabled={buttonLoading}
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Fade>
      )}

      {/* TAB 1 - Role Management */}
      {tabIndex === 1 && (
        <Fade in timeout={500}>
          <Box>
            <Card sx={{ ...cardStyle, mb: 4 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>Create New Role</Typography>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item xs={12} sm={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Role Type</InputLabel>
                      <Select
                        value={RoleType}
                        label="Role Type"
                        onChange={e => {
                          setRoleType(e.target.value)
                          if (e.target.value === 'ActivityCode') {
                            setRoleName('ActivityCode-')
                          } else {
                            setRoleName('')
                          }
                          setItems('')
                        }}
                      >
                        <MenuItem value=""><em>None</em></MenuItem>
                        <MenuItem value="Module">Module</MenuItem>
                        <MenuItem value="MenuList">MenuList</MenuItem>
                        <MenuItem value="LPage">LandingPage</MenuItem>
                        <MenuItem value="ActivityCode">ActivityCode</MenuItem>
                        <MenuItem value="New Role">New Role</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    {RoleType === 'New Role' ? (
                      <TextField
                        fullWidth
                        size="small"
                        label="Role Name"
                        value={RoleName}
                        onChange={e => {
                          setRoleName(e.target.value)
                          setItems('')
                        }}
                      />
                    ) : (
                      <Autocomplete
                        freeSolo
                        size="small"
                        options={
                          RoleType === 'ActivityCode'
                            ? ['ActivityCode-']
                            : AllRoleNames?.filter(name => !name.includes('ActivityCode-'))
                        }
                        value={RoleName}
                        onInputChange={(e, val) => {
                          setRoleName(val)
                          setItems('')
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Role Name" variant="outlined" />
                        )}
                      />
                    )}
                  </Grid>

                  {['Module', 'MenuList', 'LPage'].includes(RoleType) && RoleName && (
                    <Grid item xs={12} sm={3}>
                      <FormControl fullWidth size="small">
                        <InputLabel>{RoleType} Value</InputLabel>
                        <Select
                          value={Items}
                          label={`${RoleType} Value`}
                          onChange={e => setItems(e.target.value)}
                        >
                          <MenuItem value=""><em>Select</em></MenuItem>
                          {RoleType !== 'LPage' && <MenuItem value="*">All(*)</MenuItem>}
                          {RoleType === 'Module' && All_Modules.map((each, idx) => (
                            <MenuItem key={idx} value={each.name}>{each.name}</MenuItem>
                          ))}
                          {['MenuList', 'LPage'].includes(RoleType) && All_Menus.map((each, idx) => (
                            <MenuItem key={idx} value={each.url}>{each.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}

                  {(RoleType === 'ActivityCode' || RoleType === 'New Role') && RoleName && (
                    <Grid item xs={12} sm={3}>
                      {RoleType === 'New Role' ? (
                        <FormControl fullWidth size="small">
                          <InputLabel>Role Suffix</InputLabel>
                          <Select
                            value={Items}
                            label="Role Suffix"
                            onChange={e => setItems(e.target.value)}
                          >
                            <MenuItem value="Admin-User">Admin-User</MenuItem>
                            <MenuItem value="Dev-User">Dev-User</MenuItem>
                          </Select>
                        </FormControl>
                      ) : (
                        <TextField
                          fullWidth
                          size="small"
                          label="Activity Code"
                          value={Items}
                          onChange={e => setItems(e.target.value)}
                        />
                      )}
                    </Grid>
                  )}

                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={CreateRole}
                      sx={{ height: '40px' }}
                      disabled={!RoleType || !RoleName || RoleName === 'ActivityCode-' || !Items || buttonLoading}
                    >
                      {buttonLoading ? <CircularProgress size={24} color="inherit" /> : 'Create'}
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <Card sx={cardStyle}>
              <CardContent sx={{ p: 0 }}>
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={tableHeaderStyle}>Role Type</TableCell>
                        <TableCell sx={tableHeaderStyle}>Role Name</TableCell>
                        <TableCell sx={tableHeaderStyle}>Value</TableCell>
                        <TableCell sx={tableHeaderStyle}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {All_RA.filter(item => {
                        // Filtering logic matching original code exactly
                        if (!RoleType && !RoleName) return true;
                        if (RoleType && RoleType === item.AuthMasterObjectName && RoleName && RoleName === item.RoleName) return true;
                        if (!RoleType && RoleName && RoleName === item.RoleName) return true;
                        if ((!RoleName || RoleName === 'ActivityCode-') && RoleType && RoleType === item.AuthMasterObjectName) return true;
                        return false;
                      }).map((item, idx) => (
                        <TableRow key={idx} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell>{item.AuthMasterObjectName}</TableCell>
                          <TableCell>{item.RoleName}</TableCell>
                          <TableCell>{item.Items?.[0] || 'N/A'}</TableCell>
                          <TableCell>
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => {
                                setRoleToDelete(item.RoleName)
                                setRoleKeyToDelete({ PK: item.PK, SK: item.SK })
                                setRoleConfirmOpen(true)
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>

            <Dialog
              open={roleConfirmOpen}
              onClose={() => setRoleConfirmOpen(false)}
              PaperProps={{ sx: { borderRadius: 2, minWidth: 400 } }}
            >
              <DialogTitle sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                <WarningIcon color="warning" /> Confirm Role Deletion
              </DialogTitle>
              <DialogContent>
                <Typography>Are you sure you want to delete the role <strong>{roleToDelete}</strong>? This will remove this role configuration for the current tenant.</Typography>
              </DialogContent>
              <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={() => setRoleConfirmOpen(false)} color="inherit">Cancel</Button>
                <Button
                  onClick={() => {
                    setButtonLoading(true)
                    getRequest(`api/admin/DeleteRole?PK=${roleKeyToDelete.PK}&SK=${roleKeyToDelete.SK}&RoleName=${roleToDelete}`).then(res => {
                      setButtonLoading(false)
                      setRoleConfirmOpen(false)
                      getRequest(`api/admin/getAll_RA`).then(res => setAll_RA(res?.res?.data || []))
                    })
                  }}
                  variant="contained"
                  color="error"
                  disabled={buttonLoading}
                >
                  {buttonLoading ? <CircularProgress size={24} color="inherit" /> : 'Delete'}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Fade>
      )}

      {/* TAB 2 - Role Mapping */}
      {tabIndex === 2 && (
        <Fade in timeout={500}>
          <Box>
            <Card sx={{ ...cardStyle, mb: 4 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>Assign / Unmap Roles</Typography>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      options={AllUsers.map(u => u.USR_Email).filter(Boolean)}
                      value={Email || null}
                      onChange={(e, val) => setEmail(val || '')}
                      size="small"
                      renderInput={(params) => <TextField {...params} label="User Email" />}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Process</InputLabel>
                      <Select
                        value={Process}
                        label="Process"
                        onChange={e => setProcess(e.target.value)}
                      >
                        <MenuItem value=""><em>None</em></MenuItem>
                        <MenuItem value="Map Role">Map Role</MenuItem>
                        <MenuItem value="UnMap Role">UnMap Role</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <Autocomplete
                      freeSolo
                      options={(AllRoleNames || []).filter(Boolean)}
                      value={RoleName || null}
                      onChange={(e, val) => setRoleName(val || '')}
                      onInputChange={(e, val) => setRoleName(val)}
                      size="small"
                      renderInput={(params) => <TextField {...params} label="Role Name" />}
                    />
                  </Grid>

                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      variant="contained"
                      color={Process === 'UnMap Role' ? 'error' : 'primary'}
                      onClick={() => setRoleConfirmModalOpen(true)}
                      sx={{ height: '40px' }}
                      disabled={!Email || !RoleName || !Process || buttonLoading}
                    >
                      {buttonLoading ? <CircularProgress size={24} color="inherit" /> : (Process ? Process : 'Assign')}
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            <Card sx={cardStyle}>
              <CardContent sx={{ p: 0 }}>
                <TableContainer sx={{ maxHeight: 600 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={tableHeaderStyle}>User Email</TableCell>
                        <TableCell sx={tableHeaderStyle}>Mapped Role</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {All_UPA.filter(item => {
                        let emaiL = item.UserID.replace('#USR#', '');
                        if (!Email && !RoleName) return true;
                        if (!RoleName && Email && item.UserID.includes(Email)) return true;
                        if (RoleName && item.RoleID === RoleName && Email && item.UserID.includes(Email)) return true;
                        if (!Email && item.RoleID === RoleName) return true;
                        return false;
                      }).map((item, idx) => {
                        let emaiL = item.UserID.replace('#USR#', '');
                        return (
                          <TableRow key={idx} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell>{emaiL}</TableCell>
                            <TableCell>{item.RoleID}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Box>
        </Fade>
      )}

      {/* TAB 3 - Audit Logs */}
      {tabIndex === 3 && (
        <Fade in timeout={500}>
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <TextField
                size="small"
                placeholder="Search logs..."
                value={logSearchQuery}
                onChange={e => setLogSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
                sx={{ width: 300, backgroundColor: '#fff' }}
              />
            </Box>

            <Card sx={cardStyle}>
              <CardContent sx={{ p: 0 }}>
                <TableContainer sx={{ maxHeight: '70vh' }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={tableHeaderStyle}>Timestamp</TableCell>
                        <TableCell sx={tableHeaderStyle}>Action</TableCell>
                        <TableCell sx={tableHeaderStyle}>Performer</TableCell>
                        <TableCell sx={tableHeaderStyle}>Target</TableCell>
                        <TableCell sx={tableHeaderStyle}>Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {AllAuditLogs.filter(log => {
                        if (!logSearchQuery) return true;
                        const q = logSearchQuery.toLowerCase();
                        return (
                          (log.Action && log.Action.toLowerCase().includes(q)) ||
                          (log.Performer && log.Performer.toLowerCase().includes(q)) ||
                          (log.Target && log.Target.toLowerCase().includes(q))
                        );
                      }).map((log, idx) => (
                        <TableRow key={idx} hover>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {log.Timestamp ? new Date(log.Timestamp).toLocaleString() : 'N/A'}
                          </TableCell>
                          <TableCell>
                            <Box sx={{
                              px: 1, py: 0.5, borderRadius: '4px', display: 'inline-block',
                              bgcolor: log.Action?.includes('Delete') ? alpha('#f44336', 0.1) :
                                log.Action?.includes('Create') ? alpha('#4caf50', 0.1) : alpha('#2196f3', 0.1),
                              color: log.Action?.includes('Delete') ? '#d32f2f' :
                                log.Action?.includes('Create') ? '#2e7d32' : '#1976d2',
                              fontWeight: 600, fontSize: '0.75rem'
                            }}>
                              {log.Action}
                            </Box>
                          </TableCell>
                          <TableCell>{log.Performer}</TableCell>
                          <TableCell>{log.Target}</TableCell>
                          <TableCell>
                            <Tooltip title={JSON.stringify(log.Details, null, 2)}>
                              <Typography variant="body2" sx={{
                                maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', cursor: 'help'
                              }}>
                                {typeof log.Details === 'object' ? JSON.stringify(log.Details) : log.Details}
                              </Typography>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      ))}
                      {AllAuditLogs.length === 0 && (
                        <TableRow>
                          <TableCell colSpan={5} align="center" sx={{ py: 3, color: 'text.secondary' }}>
                            No audit logs found.
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Box>
        </Fade>
      )}

      {/* TAB 4 - Menu Management */}
      {tabIndex === 4 && (
        <MenuManagement
          AllRoles={AllRoleNames}
          allMenusData={allMenusData}
          refreshData={fetchMenuData}
        />
      )}

      {/* Role Mapping Confirmation Dialog */}
      <Dialog
        open={roleConfirmModalOpen}
        onClose={() => setRoleConfirmModalOpen(false)}
        PaperProps={{ sx: { borderRadius: '12px', minWidth: '350px' } }}
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Confirm Role Action</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to <strong>{Process}</strong> for user <strong>{Email}</strong>?
            <br />
            Role: <strong>{RoleName}</strong>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setRoleConfirmModalOpen(false)} color="inherit">Cancel</Button>
          <Button
            onClick={MapRole}
            variant="contained"
            color={Process === 'UnMap Role' ? 'error' : 'primary'}
            disabled={buttonLoading}
          >
            {buttonLoading ? <CircularProgress size={24} color="inherit" /> : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={userSaveConfirmModalOpen}
        onClose={() => setUserSaveConfirmModalOpen(false)}
        PaperProps={{ sx: { borderRadius: '12px', minWidth: '350px' } }}
      >
        <DialogTitle sx={{ fontWeight: 600 }}>Confirm User Save</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to <strong>{isEditMode ? 'update' : 'create'}</strong> user <strong>{nameofuser}</strong>?
            <br />
            Email: <strong>{Email}</strong>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setUserSaveConfirmModalOpen(false)} color="inherit">Cancel</Button>
          <Button
            onClick={handleSaveUser}
            variant="contained"
            color="primary"
            disabled={buttonLoading}
          >
            {buttonLoading ? <CircularProgress size={24} color="inherit" /> : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>



      {/* Infrastructure Setup Dialog */}
      <Dialog
        open={infraDialogBoxOpen}
        onClose={() => !infraLoading && setInfraDialogBoxOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: '12px' } }}
      >
        <DialogTitle sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
          <RocketLaunchIcon color="primary" /> Infrastructure Setup - {Tenant}
        </DialogTitle>
        <DialogContent dividers>
          {!infraResults ? (
            <Box sx={{ py: 2 }}>
              <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                This will provision S3 buckets, DynamoDB, PostgreSQL tables, and list XLSX files for the tenant.
              </Typography>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Environment</InputLabel>
                    <Select
                      value={infraEnv}
                      label="Environment"
                      onChange={e => setInfraEnv(e.target.value)}
                    >
                      <MenuItem value="dev">Development (Dev)</MenuItem>
                      <MenuItem value="prod">Production (Prod)</MenuItem>
                      <MenuItem value="both">Both (Dev & Prod)</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Box sx={{ py: 1 }}>
              {Object.entries(infraResults).map(([env, status]) => (
                <Box key={env} sx={{ mb: 3 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700, textTransform: 'uppercase', mb: 1, color: 'primary.main' }}>
                    {env} Environment
                  </Typography>
                  <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #eee', borderRadius: '8px' }}>
                    <Table size="small">
                      <TableBody>
                        {Object.entries(status).map(([service, state]) => (
                          <TableRow key={service}>
                            <TableCell sx={{ fontWeight: 600, textTransform: 'uppercase', width: '30%' }}>{service}</TableCell>
                            <TableCell>
                              {Array.isArray(state) ? (
                                <Box sx={{ maxHeight: 100, overflow: 'auto' }}>
                                  <ul style={{ margin: 0, paddingLeft: '1.2rem', fontSize: '0.8rem' }}>
                                    {state.map((item, i) => <li key={i}>{item}</li>)}
                                  </ul>
                                </Box>
                              ) : (
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 600,
                                    color: (state === 'already there' || state?.includes('✅')) ? 'info.main' :
                                      (state === 'created' || state?.includes('created')) ? 'success.main' : 'error.main'
                                  }}
                                >
                                  {state}
                                </Typography>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button onClick={() => setInfraDialogBoxOpen(false)} color="inherit" disabled={infraLoading}>
            {infraResults ? 'Close' : 'Cancel'}
          </Button>
          {!infraResults && (
            <Button
              onClick={runInfraSetup}
              variant="contained"
              color="primary"
              disabled={infraLoading || !Tenant}
              startIcon={infraLoading ? <CircularProgress size={20} color="inherit" /> : <RocketLaunchIcon />}
            >
              {infraLoading ? 'Setting up...' : 'Run Setup'}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  </>);
}
export default AdminScreen;